import styled from "styled-components";
import { media } from "../../theme";

const Container = ({ children }: any) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default Container;

/*
 * 40px dolgu 390px'lik bir ekranda içeriğe kalan genişliğin %20'sini yiyordu.
 * Bu bileşen 36 sayfada kullanılıyor; dolgu burada küçülünce hepsi düzeliyor.
 */
const StyledContainer = styled.div`
  padding: 40px;
  background-color: #ffffff;
  // &:hover {
  //   background-color: #f3f3f3;
  // }
  position: relative;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;

  ${media.compact} {
    padding: 24px;
  }

  ${media.mobile} {
    padding: 16px;
  }
`;
